export const minOdd = 1.01;
export const defaultMinOdd = 2;

export const additionalBetAmountChangingButtons = {
  typing: 'typing',
  plus: 'plus',
  minus: 'minus',
  min: 'min',
  max: 'max',
  allIn: 'allIn',
  double: 'double',
  divide: 'divide',
};

export const autoCashOutDataKeys = {
  isOpened: 'isOpened',
  isBlurred: 'isBlurred',
  autoCashOutOdd: 'autoCashOutOdd',
  isValidatedOdd: 'isValidatedOdd',
  autoCashOutMaxOdd: 'autoCashOutMaxOdd',
};

export const autoBetDataKeys = {
  isAutoBet: 'isAutoBet',
  isOpened: 'isOpened',
  autoBetCount: 'autoBetCount',
};

export const betSectionTabsName = {
  markets: 'markets',
  manual: 'manual',
};

export const numPadSectionName = {
  ...betSectionTabsName,
  autoCashOutOdd: 'autoCashOutOdd',
};

export const autoBetCountList = [5, 10, 20, 50, 99];

export const oddDataForHelpPopUp = [
  { odd: '19.4', range: '1' },
  { odd: '3', range: '1.01-1.5' },
  { odd: '2', range: '1.01-2' },
  {
    odd: '3.35',
    range: '2.01-5',
  },
  { odd: '10', range: '5.01-10' },
  { odd: '20', range: '10.01-20' },
  { odd: '33', range: '20.01-50' },
  { odd: '100', range: '50.01-100' },
];

export const videoTypes = {
  start: 'start',
  kick: 'kick',
  process: 'process',
  finish: 'finish',
};

export const terminalTableOdd = [
  1.5, 1.7, 2, 2.3, 2.5, 2.7, 3, 3.5, 4, 4.5, 5, 7, 8, 10, 15, 25, 50, 100, 200, 300, 500, 1000,
  2000, 3000, 10000, 25000, 30000, 50000,
];

export const socketEventsHandlerDelays = {
  handleBetsClosed: 2500,
  handleRoundStart: 300,
  handleDoBetResult: 450,
  handleResultReport: 5000,
  handleRoundFin: 1000,
};
